import {EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {PricingScheduleData} from "./pricing-schedule.data";

@Injectable()
export abstract class PricingScheduleEntityModel<T> extends EntityModel<PricingScheduleData<T>> {

    constructor(injector: Injector, dataType: any) {
        super(injector, dataType);
    }

    protected override onBeforeSaveEntity(schedule: PricingScheduleData<T>): void {
        if (!schedule.recurring) {
            schedule.frequency = 0;
            schedule.finish = schedule.start;
        }
    }
}
